import posthog from 'posthog-js';
import { appConfig } from '@/config/env';

/**
 * Manual `$pageview` for PostHog: the provider runs with `capture_pageview: false`, and the quiz changes
 * screens without a route change, so the host reports one pageview per screen. `$current_url` is what
 * heatmaps and session replay group by, so it is sent explicitly from the already-updated address bar.
 * A pageview that arrives before posthog-js is initialised is kept (last one wins) and flushed later.
 */
let pending: string | undefined;
let lastSent: string | undefined;
let flushTimer: ReturnType<typeof setInterval> | undefined;

const send = (pathname: string): void => {
  if (pathname === lastSent) return;
  lastSent = pathname;
  try {
    posthog.capture('$pageview', { $current_url: globalThis.location?.href, funnel_screen: pathname });
  } catch {
    // Analytics must never break the funnel.
  }
};

/** Sends the pageview kept from before init, once posthog is loaded. */
export const flushPendingPageview = (): void => {
  if (!pending || !posthog.__loaded) return;
  const pathname = pending;
  pending = undefined;
  if (flushTimer) clearInterval(flushTimer);
  flushTimer = undefined;
  send(pathname);
};

/** Test hook. */
export const resetPageviews = (): void => {
  pending = undefined;
  lastSent = undefined;
  if (flushTimer) clearInterval(flushTimer);
  flushTimer = undefined;
};

export const capturePageview = (pathname: string): void => {
  if (appConfig.query.preview) return;
  if (!posthog.__loaded) {
    pending = pathname;
    // Provider init runs in the background; poll briefly instead of wiring into its lifecycle.
    flushTimer ??= setInterval(flushPendingPageview, 500);
    return;
  }
  send(pathname);
};
